var map = {
	"./decidim/avatar-multiuser.png": 32107,
	"./decidim/brands/google.svg": 38746,
	"./decidim/cc-badge.png": 10937,
	"./decidim/decidim-logo.svg": 52665,
	"./decidim/default-avatar.svg": 86473,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 3695,
	"./decidim/icons.svg": 54280,
	"./decidim/pattern.png": 20987,
	"./decidim/placeholder.jpg": 58922,
	"./decidim/vendor/leaflet/layers-2x.png": 63529,
	"./decidim/vendor/leaflet/layers.png": 6880,
	"./decidim/vendor/leaflet/marker-icon-2x.png": 93233,
	"./decidim/vendor/leaflet/marker-icon.png": 79704,
	"./decidim/vendor/leaflet/marker-shadow.png": 55847,
	"./decidim/vendor/social-share-button/delicious.svg": 28987,
	"./decidim/vendor/social-share-button/douban.svg": 21091,
	"./decidim/vendor/social-share-button/email.svg": 47580,
	"./decidim/vendor/social-share-button/facebook.svg": 46792,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 32300,
	"./decidim/vendor/social-share-button/google_plus.svg": 45684,
	"./decidim/vendor/social-share-button/hacker_news.svg": 60784,
	"./decidim/vendor/social-share-button/linkedin.svg": 31866,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 24483,
	"./decidim/vendor/social-share-button/pinterest.svg": 64970,
	"./decidim/vendor/social-share-button/qq.svg": 37750,
	"./decidim/vendor/social-share-button/reddit.svg": 80704,
	"./decidim/vendor/social-share-button/telegram.svg": 45445,
	"./decidim/vendor/social-share-button/tumblr.svg": 4354,
	"./decidim/vendor/social-share-button/twitter.svg": 25369,
	"./decidim/vendor/social-share-button/vkontakte.svg": 40563,
	"./decidim/vendor/social-share-button/wechat.svg": 69886,
	"./decidim/vendor/social-share-button/weibo.svg": 77856,
	"./decidim/vendor/social-share-button/whatsapp.svg": 53718,
	"./decidim/vendor/social-share-button/x.svg": 26324,
	"./decidim/vendor/social-share-button/xing.svg": 62340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4710;